







































































































































































































import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { darkTextTableColumns, loopDarkTextTableColumns } from '../config/colums'
import {
  getList,
  createDarkText,
  publishDarkText,
  deleteDarkText,
  changeDarkTextPosition,
  getLoopTypeOneList,
  cycleConfig,
  getCycleConfig
} from '../../../service/search'
import { addWatermarker } from '../../../utils/renderWatermarker'
import { USER_NAME } from '../../../service/constant'
@Component
export default class DarkText extends Vue {
  isLoopDarkText: boolean = false // 是否是循环暗文
  async mounted() {
    this.renderWaterMarker()
    this.renderList(1)
    this.renderLoopTypeOneList()
  }
  get userName() {
    return this.$store.state[USER_NAME]
  }
  renderWaterMarker() {
    const document: Document = window.document
    addWatermarker(document.querySelector('.dark-text-content'), `17题库 ${this.userName}`)
  }
  public darkTextTableColumns: any[] = darkTextTableColumns
  public loopDarkTextTableColumns: any[] = loopDarkTextTableColumns
  public isModalVisibale: boolean = false
  public confirmLoading: boolean = false
  public dataSource: any[] = []
  public content: string = ''
  private type = ''

  private types: any[] = []

  private moduleFit = ''
  private fitTypes: any[] = []

  public pagination = {
    current: 1,
    pageSize: 10,
    total: 0,
    showTotal: (total) => `共 ${total} 条`
  }

  // 循环暗文
  get sumOfPages() {
    const { pageSize, total } = this.pagination
    return Math.ceil(total / pageSize)
  }
  get numberOfLastPage() {
    const { pageSize, total } = this.pagination
    return total % pageSize
  }
  private formItemLayout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 17 }
  }
  contentValue: string = ''
  moduleValue: number = 1
  moduleOptions = [
    { label: '平台', value: 1 },
    { label: '趣味配音', value: 2 },
    { label: '绘本', value: 3 },
    { label: '分级阅读', value: 4 },
    { label: '轻课', value: 5 },
    { label: '范文素材', value: 6 }
  ]
  contentTypeValue: number = -1
  contentTypeOptions = [
    { label: '请选择', value: -1 },
    { label: '引导型', value: 1 },
    { label: '搜索型', value: 2 },
    { label: '循环型', value: 3 }
  ]
  statusValue: number = -1
  statusOptions = [
    { label: '不限', value: -1 },
    { label: '未发布', value: 0 },
    { label: '已发布', value: 1 }
  ]
  handleSearch() {
    this.renderList(1)
  }
  async handleChangeItemPosition(record, action) {
    const options = {
      module: this.moduleValue,
      content: this.contentValue,
      status: record.status,
      content_id: record.id,
      action
    }
    const { success, msg: message } = await changeDarkTextPosition(options)

    if (success) {
      this.$message.success(message)
      this.renderList(this.pagination.current)
    } else {
      this.$message.error(message)
    }
  }
  isLoopModalVisibale: boolean = false
  loopConfirmLoading: boolean = false
  loopModelValue: number = 1
  loopTypeValue: string[] = []
  loopTypeOptions = []
  loopNumber: number = 5
  async showLoopModal() {
    this.isLoopModalVisibale = true
    this.changeLoopTypa()
  }
  handleLoopModelChange(value) {
    this.changeLoopTypa()
  }
  async changeLoopTypa() {
    const options = {
      module: this.loopModelValue
    }
    const { success, data } = await getCycleConfig(options)

    if (success) {
      const { count, type_one } = data

      this.loopNumber = count
      this.loopTypeValue = type_one.map((item) => item.type_id)
    }
  }
  async handleLoopModalOk() {
    this.loopConfirmLoading = true
    const options = {
      module: this.loopModelValue,
      type_one: this.loopTypeValue.join(','),
      count: this.loopNumber
    }
    const { success, msg } = await cycleConfig(options)

    if (success) {
      this.loopConfirmLoading = false
      this.$message.success(msg)
      this.renderList(1)
      this.isLoopModalVisibale = false
    } else {
      this.loopConfirmLoading = false
    }
  }
  handleLoopModalCancel() {
    this.isLoopModalVisibale = false
  }
  async renderLoopTypeOneList() {
    const { success, msg, data } = await getLoopTypeOneList({})

    if (success) {
      // 排除 3 个
      const excludedItems = ['ALL', 'WORD', 'IDIOM']
      this.loopTypeOptions = data.records
        .filter((item) => !excludedItems.includes(item.type_id))
        .map((item) => {
          return {
            label: item.type_name,
            value: item.type_id
          }
        })
    }
  }
  // 循环暗文 end

  async renderList(page) {
    const options = {
      content: this.contentValue,
      content_type: this.contentTypeValue,
      module: this.moduleValue,
      status: this.statusValue,
      page,
      page_size: this.pagination.pageSize
    }
    const { list, total } = await getList(options)

    this.isLoopDarkText = this.contentTypeValue === 3 ? true : false
    this.dataSource = list.map((item) => {
      return {
        operation: item.status,
        ...item
      }
    })
    this.pagination.total = total
    this.pagination.current = page
  }
  handleTableChange(pagination) {
    this.renderList(pagination.current)
  }
  showModal() {
    this.isModalVisibale = true
    ;(this.types = [
      {
        label: '引导型',
        value: 1
      },
      {
        label: '搜索型',
        value: 2
      },
      {
        label: '循环型',
        value: 3
      }
    ]),
      (this.fitTypes = [
        {
          label: '平台',
          value: 1
        },
        {
          label: '趣味配音',
          value: 2
        },
        {
          label: '绘本',
          value: 3
        },
        {
          label: '分级阅读',
          value: 4
        },
        {
          label: '轻课',
          value: 5
        },
        {
          label: '范文素材',
          value: 6
        }
      ])
  }

  async handleModalOk(e) {
    const obj = [
      { label: '暗文内容', value: this.content },
      { label: '适用模块', value: this.moduleFit },
      { label: '暗文类型', value: this.type }
    ]
    for (var i = 0; i < obj.length; i++) {
      if (!obj[i].value) {
        this.$message.warning('请填写' + obj[i].label)
        return
      }
    }

    this.confirmLoading = true
    const options = {
      content: this.content,
      module: this.moduleFit,
      type: this.type
    }

    const { success, msg: message } = await createDarkText(options)
    if (success) {
      this.$message.success(message)
      this.confirmLoading = false
      this.isModalVisibale = false
      this.content = ''
      this.moduleFit = ''
      this.type = ''
      this.types = []
      this.renderList(1)
    } else {
      this.confirmLoading = false
    }
  }
  handleTypeChange(value) {
    this.type = value
  }

  handleFitChange(value) {
    this.moduleFit = value
  }

  handleModalCancel(e): void {
    this.isModalVisibale = false

    this.content = ''
    this.type = ''
    this.types = []

    this.moduleFit = ''
    this.fitTypes = []
  }
  async handlePublishItem(record) {
    const options = {
      text_id: record.id,
      action: 1
    }
    const { success, msg: message } = await publishDarkText(options)
    if (success) {
      this.$message.success(message)
      this.renderList(1)
    } else {
      // this.$message.error(message)
    }
  }
  async handleCancelItem(record) {
    const options = {
      text_id: record.id,
      action: 0
    }
    const { success, msg: message } = await publishDarkText(options)
    if (success) {
      this.$message.success(message)
      this.renderList(1)
    } else {
      this.$message.error(message)
    }
  }
  async handleDeleteItem(record) {
    const options = {
      text_id: record.id
    }
    const { success, msg: message } = await deleteDarkText(options)
    if (success) {
      this.$message.success(message)
      const newData = [...this.dataSource]
      newData.splice(record.key, 1)
      this.dataSource = newData

      let page = 0
      if (newData.length) {
        page = this.pagination.current
      } else {
        page = this.pagination.current === 1 ? 1 : this.pagination.current - 1
      }
      this.renderList(page)
    } else {
      this.$message.error(message)
    }
  }
}
